<template>
  <div class="text-block">
    <div class="text-block__content">
      <h1 class="text-block__content--title scrollFadeText">{{ title }}</h1>
      <p class="text-block__content--body scrollFadeBody">{{ content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextBlock",
  props: {
    title: {
      default: '',
      required: false,
    },
    content: {
      default: '',
      required: false
    },
  },
}
</script>

<style scoped>

</style>
